import React, { Component } from 'react'; //different
//import './style.css';
import instance from "./axios-instance";
import SweetAlert from 'react-bootstrap-sweetalert';
import jwt_decode from "jwt-decode";
import NavMenu from './navmenu';
import Systems from "./SystemFunction";
import Banner from './banner';
import MoblieMenu from "./mobilemenu";
import TextSlider from './textslide';
class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            categorylist: [],
            rewardlist: [],
            activePage: 1,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: false, // Indicates in progress state of login form
            pagecount: 1,
            playerid: null,
            user_id: props.props.username,
            products_page_count: 1,
            loginstate: props.props.loginstate,
            firstname: null,
            lastname: null,
            alert: null,
        }
        this.handleClick = this.handleClick.bind(this);

    }
    handlePageChange(pageNumber) {
        //////console.log(`active page is ${pageNumber}`);
        this.setState({ activePage: pageNumber });

        instance
            .get("/api/v1/rewardlist", {
                params: {
                    Cat_ID: 0,
                    page: pageNumber
                }
            })
            .then((res) => {
                this.setState({
                    rewardlist: res.data.message.products,
                    pagecount: res.data.message.pagecount,
                    products_page_count: res.data.message.products_page_count
                });
            });
    }

    handleClick = async (e) => {
        this.setState({
            activePage: 1,
            isActive: true,
            activeTab: 0
        });
        instance.get("/api/v1/rewardlist", {
            params: {
                Cat_ID: e.target.id,
                page: 1
            }
        })
            .then((res) => {
                this.setState({
                    rewardlist: res.data.message.products,
                    pagecount: res.data.message.pagecount,
                    products_page_count: res.data.message.products_page_count
                });
            });
        this.setState({
            isActive: false
        });
    }

    hideAlert() {
        this.setState({
            alert: null
        });
    }


    checklogin() {
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            this.setState({
                user_id: decoded.message.playerid,
                playerid: decoded.message.member_id,
                firstname: decoded.message.firstname,
                lastname: decoded.message.lastname,
                point: decoded.message.Point,
                loginstate: true,
            });
        }
        else {
            this.setState({
                loginstate: false,
            });
        }
    }

    async componentDidMount() {
        var token = localStorage.getItem('auth_token');
        const search = window.location.href;
        const params = new URLSearchParams(search);
        //////console.log(params);
        this.checklogin();
        await instance.post("/api/v1/tabgamelist", {
            state: "77",
            System: Systems,
        })
            .then((res) => {
                if (res.data.status === 200) {
                    this.setState({
                        categorylist: res.data.message
                    });
                }
                else {
                   // this.CheckThisGoalError();
                }
            });

    }

    render() {
        return (
            <>
                <div>
                    <main className="container p-0">
                        <div className="p-1 text-left container-xl text-white mt-1 my5 animated animatedFadeInUp fadeInUp">
                            {/**/}
                            <div className="clearfix">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h4 className="ps-2 mb-0 f-22 text-title">
                                            <b>กีฬา</b>
                                        </h4>
                                    </div>
                                    <div>
                                        {/* [2026-11-04] ปุ่มย้อนกลับหน้าแรก (เดิมเป็นรูปว่าง ไม่มีทางกลับ) */}
                                        <a role="button" aria-label="ย้อนกลับ" onClick={() => { window.location.href = '/'; }}
                                            style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "4px 14px", borderRadius: 999, background: "rgba(0,0,0,.45)", border: "1px solid rgba(255,255,255,.35)", color: "#fff", fontSize: 14, lineHeight: "20px", cursor: "pointer", textDecoration: "none", whiteSpace: "nowrap" }}>
                                            <span style={{ fontSize: 18, lineHeight: "18px" }}>‹</span> ย้อนกลับ
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="pt-1 pb-3 text-white w-scroll-height">
                            <div className="x-category-provider js-game-scroll-container js-game-container animated animatedFadeInUp fadeInUp">
                                <div className="-games-list-container container">
                                    <nav className="nav-menu" id="navbarProvider">
                                        <ul className="nav nav-pills row animated animatedFadeInUp fadeInUp">
                                            {this.state.categorylist.map((listitem, i) => (
                                                <li className="col-4 col-lg-4 col-md-4 nav-item card-width -random-container -game-sport-macro-container p-1 pb-0 mb-2">
                                                    <a  href={"/listgameall/sport/" + listitem.partner} key={i} id={listitem.gameid}>
                                                    <div
                                                            className="x-game-list-item-macro js-game-list-toggle -big -cannot-entry -untestable example"
                                                            data-status="-cannot-entry -untestable"
                                                        >
                                                            <div className="-inner-wrapper card-width-banner">
                                                                <div>
                                                                    {/**/}
                                                                    {/**/}
                                                                    {/**/}
                                                                </div>
                                                                <picture>
                                                                    <img loading="lazy" decoding="async"
                                                                        role="button"
                                                                        className="w-100 hover-slot hoverTextCss"
                                                                        lazy="loaded"
                                                                        data-src={listitem.imagesec}
                                                                        src={listitem.imagesec}
                                                                    />
                                                                </picture>
                                                                <div className="-overlay d-none d-lg-block">
                                                                    <div className="-overlay-inner">
                                                                        <div className="-wrapper-container">
                                                                            <button href={"/listgameall/sport/" + listitem.partner} className="-btn -btn-play js-account-approve-aware"  >
                                                                                <i className="fas fa-play" />
                                                                                <span className="-text-btn">เข้าเล่น</span>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="-title mt-1 mb-0 text-center text-color-name-game">
                                                                {listitem.description}
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>

                                            ))}
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </main >
                </div >

            </>
        );
    }
}
export default App;
